import { country } from './country';

export interface PatternsConfig {
  licensePlate: LicensePlatePattern[];
  phoneNumber: country[];
}

export interface LicensePlatePattern {
  value: country;
  isSearchActive: { customer: boolean; insurer: boolean };
}
